import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";

import cover from "../assets/img/landing port horiz.png";
// import cover from "../assets/img/procedural-editor.png";
import video from "../assets/vid/procedural-video.mp4";


export const projectDetails: ProjectInterface = {
    url: "projects",
    title: "See all projects",
    summary: "",
    description: ``,
    year: "",
    tags: [""],
    imageSrc: cover,
    hasVideo: false,
    startVideoTime: 0,
    videoSrc: video,
    isCoverType: false,
    haveTags: true,
    projectType: ProjectType.NONE,
    roles: [""],
    technologies: [""],
    collaborators: [""],
    highlightColor: "#60151F",
    descriptionTitle: "",
    linkData: [],
    isCheckMoreProjects: true
};